import { useQuery } from '@tanstack/react-query';
import { getArtistMembers } from '@/apis/main';
import { useContext, useEffect, useRef } from 'react';
import { PhotocardsContext } from '@/routes/photocard/_components/Provider';
import { ArtistMember } from '@/types/photocard';
import { Swiper as SwiperCore } from 'swiper/types';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { FreeMode } from 'swiper/modules';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { IToggleTrigger } from '@/hooks/useToggle';
import FilterBar from '@/routes/photocard/_components/FilterBar/FilterBar';

const allMember = [{ id: 0, name: 'All', name_en: 'All', image: '' }];

interface IProps {
  sortModal: IToggleTrigger;
  typeSectionModal: IToggleTrigger;
}

const MemberFilter = ({ sortModal, typeSectionModal }: IProps) => {
  const { group, member, setMember } = useContext(PhotocardsContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const swiperRef = useRef<SwiperCore>();

  const { data } = useQuery({
    queryFn: () => getArtistMembers(group.id ?? 5),
    queryKey: ['member-list', group.id ?? 5],
    select: (data) => data.members
  });
  const artistMembers = data;

  const onClick = (clickedMember: ArtistMember) => {
    swiperRef.current?.slideTo(swiperRef.current?.clickedIndex - 4);
    const targetArtistMember = artistMembers?.find((item) => item === clickedMember);
    if (targetArtistMember) {
      setMember(targetArtistMember);
      searchParams.set('member', String(targetArtistMember.id));
      // searchParams.delete('q');
      navigate(`${location.pathname}?${searchParams}`);
    }
  };

  useEffect(() => {
    artistMembers && setMember(artistMembers[0].name !== '태일' ? artistMembers[0] : artistMembers[1]);
  }, [data]);

  return (
    <div className="grid grid-cols-[1fr_auto] items-center fixed left-[260px] top-[75px] w-[calc(100%-260px)] bg-white h-15 z-10">
      <Swiper
        onBeforeInit={(swiper) => (swiperRef.current = swiper)}
        slidesPerView="auto"
        spaceBetween={8}
        modules={[FreeMode]}
        freeMode={{
          sticky: true,
          momentum: true,
          momentumRatio: 2,
          momentumVelocityRatio: 0.3
        }}
        className="min-w-0 w-full overflow-x-auto no-scrollbar !px-4 !py-3 h-[62px] bg-white"
      >
        {artistMembers?.map(
          (artist) =>
            artist.name !== '태일' && (
              <SwiperSlide
                key={artist.name_en}
                className={`h-9 py-2 px-[12px] flex items-center justify-center rounded-[10px] border ${
                  member?.name_en === artist.name_en ? 'border-[#FF6060] bg-[#FFF2F2]' : 'border-[#ededed]'
                } !w-auto`}
                onClick={() => onClick(artist)}
              >
                <span
                  className={`text-[14px] flex ${
                    member?.name_en === artist.name_en ? 'text-[#FF6060] font-semibold' : 'text-[#BFBFBF] font-medium'
                  }`}
                >
                  {artist.name_en}
                </span>
              </SwiperSlide>
            )
        )}
      </Swiper>
      <FilterBar sortModal={sortModal} typeSectionModal={typeSectionModal} />
    </div>
  );
};

export default MemberFilter;
